import styled from 'styled-components';

const Divider = styled.div`
  color: ${props => props.theme.colorPrimary};
  font-size: 12px;
  font-weight: 200;
  align-self: center;
  padding: 0 2rem;
`;

export default Divider;


// WEBPACK FOOTER //
// ./src/components/Divider/Divider.js